"use client" // Error components must be Client Components

import ErrorView from "@/components/ErrorView"
import {
  useEffect
} from "react"

export default function Error({
  error,
}:{
  error: any
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <html>
      <body>
        <ErrorView />
      </body>
    </html>
  )
}

